import { useAuth } from 'context/AuthProvider';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { apiEmpleadosService } from 'services/apiEmpleadosService';
import EmpleadoDetalleHorario from './detalle/EmpleadoDetalleHorario';
import EmpleadoDetallesGenerales from './detalle/EmpleadoDetallesGenerales';
import EmpleadoDetalleCalendario from './detalle/EmpleadoDetalleCalendario';
import ComputoAusenciasAnual from "../motivoAusencias/ComputoAusenciasAnual";

const VerDetalleEmpleado = () => {
    const { empresa } = useAuth();
    const { id } = useParams();
    const [empleado, setEmpleado] = useState(null)


   


    useEffect(() => {
        const fetchData = async () => {
            const responseEmpleados = await apiEmpleadosService.get(empresa.id, id)
            setEmpleado(responseEmpleados)
       
        }
        fetchData()
        return () => {

        }
    }, [id, empresa.id])


    return (
        <div>
            {
                empleado && (<>
                    <EmpleadoDetallesGenerales empleado={empleado}></EmpleadoDetallesGenerales>

                    <EmpleadoDetalleHorario empleado={empleado}></EmpleadoDetalleHorario>

                    <EmpleadoDetalleCalendario empleado={empleado}></EmpleadoDetalleCalendario>

                    <h3>Recuento Ausencias anuales año {new Date().getFullYear()}</h3>
                    <ComputoAusenciasAnual empleadoId={empresa.id} year={new Date().getFullYear()}/>
                </>)
            }



        </div>
    )
}

export default VerDetalleEmpleado